import { render, staticRenderFns } from "./userslist.vue?vue&type=template&id=55ca3f23"
import script from "./userslist.vue?vue&type=script&lang=js"
export * from "./userslist.vue?vue&type=script&lang=js"
import style0 from "./userslist.vue?vue&type=style&index=0&id=55ca3f23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports